export class LabcoreEmailFile {
    constructor(
        public emailUsuario?: string,
        public nombreUsuario?: string,
        public emailsCC?: string[],
        public numeroOrden?: string,
        public archivoStringBase64?: string
    ){
        this.emailsCC = [];
    }    
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/labcore-email-file.model.ts